import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { RequestAppointmentComponent } from './request-appointment.component';
import { ViewCalendarComponent } from './view-calendar/view-calendar.component';
import { ListMemberComponent } from './list-member/list-member.component';

const requestAppointmentRoutes: Routes = [
  { path: '', component: RequestAppointmentComponent },
  { path: ':id', component: RequestAppointmentComponent },
  { path: 'view-calendar', component: ViewCalendarComponent },
  { path: 'list-member/:id', component: ListMemberComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(requestAppointmentRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class RequestAppointmentRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/request-appointment.routing.ts